export class SubscribeTarifarioRequest {
  /** 40 CajaPlus*/
  tiposMedioPagoId: number[];
  /** S subcribir D desubscribir */
  operacion: string;

  gatewayAgrupador: boolean;
}
